module.exports = __webpack_public_path__ + "media/images/screenshots/changelog-3c14db64438ed7d155377bbde1247395.png";